var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { ELSIcon } from '@els/els-component-form-field-react';
import { ELSInlineLoader } from '@els/els-ui-common-react';
import classNames from 'classnames';
import { APP_DEFAULT_NAV_ITEMS, FeatureFlagNames, RoutePath, TAB_NAV_ITEMS_NAME } from 'constants/app.constant';
import { APP_LINK_PAGE_NAME_WITH_ROUTE, EXTERNAL_APP_INFO } from 'constants/externalApp.constant';
import { checkPathMatch, isEnabledMockService } from 'helpers/app.helper';
import { cloneDeep } from 'lodash';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { appActions, appSelectors } from 'redux/ducks/app';
import { PerformancePath } from 'reports/cw/constants/cw.constant';
import useSafeMedCourse from 'reports/cw/hooks/shared/useSafeMedCourse';
import { ehrPath } from 'reports/ehr/constants/ehr.constant';
import HADPageNavigatorModal from 'reports/had/components/common/page-navigator/HADPageNavigatorModal';
import { isFeatureEnabled } from 'services/feature-flag.service';
import ButtonMenu from '../button-menu/ButtonMenu';
import withRedirectToOutsideApp from '../with-redirect-to-outside-app/withRedirectToOutsideApp';
import withResizeScreen from '../with-resize-screen/withResizeScreen';
import PageNavigatorModal from './PageNavigatorModal';
export var renderNavButton = function (name, onActionClick, isLinkActive) {
    return (<button key={name} type="button" tabIndex={0} className={classNames('u-els-anchorize c-els-tab-group__item c-els-tab-group__item-link', { 'c-els-tab-group__item--active': isLinkActive })} onClick={function () { return onActionClick(); }}>
      <span className="c-els-tab-group__text">{name}</span>
    </button>);
};
var PageNavigator = function (_a) {
    var openModal = _a.openModal, isCWLinkHADAndEHRChecking = _a.isCWLinkHADAndEHRChecking, handleCancel = _a.handleCancel, windowMode = _a.windowMode, eaqTopicMappedHesiExamByCourseId = _a.eaqTopicMappedHesiExamByCourseId, isHesiReadinessApp = _a.isHesiReadinessApp, currentAppLinkPage = _a.currentAppLinkPage, isHADPath = _a.isHADPath, onRedirectToOutsideApp = _a.onRedirectToOutsideApp, studentNameDisplay = _a.studentNameDisplay, isShowEAQTopicReport = _a.isShowEAQTopicReport, isCWSubNavInEHRPageShow = _a.isCWSubNavInEHRPageShow, appLinkOutPostBody = _a.appLinkOutPostBody, isEhrReportingEnabled = _a.isEhrReportingEnabled, isCSApp = _a.isCSApp;
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isEAQTopicReportFFEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.USPD_EAQ_TOPIC_REPORT_ENABLED);
    var _b = useState(''), activePageName = _b[0], setActivePageName = _b[1];
    var dispatch = useDispatch();
    var history = useHistory();
    var isSafeMedCourse = useSafeMedCourse().isSafeMedCourse;
    var goToEAQReport = function () { return __awaiter(void 0, void 0, void 0, function () {
        var body, linkConfig;
        return __generator(this, function (_a) {
            if (isEAQTopicReportFFEnabled) {
                history.push(PerformancePath.eaqTopicReport.home);
                return [2 /*return*/];
            }
            body = {
                performanceReportPage: currentAppLinkPage
            };
            linkConfig = {
                appName: EXTERNAL_APP_INFO.APP_LINKING.EAQ.APP_NAME,
                action: EXTERNAL_APP_INFO.APP_LINKING.EAQ.ACTION.PERFORMANCE_VIEW,
                isIncludeLinkHash: false
            };
            onRedirectToOutsideApp(linkConfig, { data: body });
            return [2 /*return*/];
        });
    }); };
    var getInitialNavItems = function () {
        if (isShowEAQTopicReport && !isCSApp && !isEnabledMockService()) {
            var combinedNavItems = cloneDeep(APP_DEFAULT_NAV_ITEMS);
            var eaqTopicReportNavItem = __assign({ name: TAB_NAV_ITEMS_NAME.EAQ_TOPIC_REPORT, onClickCustomLink: goToEAQReport }, (isEAQTopicReportFFEnabled && { paths: [PerformancePath.eaqTopicReport.home] }));
            combinedNavItems.default = __spreadArray(__spreadArray([], combinedNavItems.default, true), [eaqTopicReportNavItem], false);
            return combinedNavItems;
        }
        return APP_DEFAULT_NAV_ITEMS;
    };
    var _c = useState(function () { return getInitialNavItems(); }), navItems = _c[0], setNavItems = _c[1];
    var handleGetActiveName = useCallback(function () {
        var mergedNavItems = __spreadArray(__spreadArray(__spreadArray([], navItems.default, true), navItems.expand, true), navItems.extraActive, true);
        mergedNavItems.forEach(function (item) {
            var name = item.name, paths = item.paths;
            var match = paths ? checkPathMatch(paths) : false;
            if (match) {
                setActivePageName(name);
            }
        });
    }, [navItems.default, navItems.expand, navItems.extraActive]);
    useEffect(function () {
        handleGetActiveName();
    }, [handleGetActiveName]);
    useEffect(function () {
        if (studentNameDisplay) {
            setActivePageName(studentNameDisplay);
        }
    }, [studentNameDisplay]);
    useEffect(function () {
        if (!isSafeMedCourse)
            return;
        setNavItems(function (prev) {
            if (prev.default.some(function (item) { return item.name === TAB_NAV_ITEMS_NAME.ASSESSMENT_SUMMARY; }))
                return prev;
            var eaqIndex = prev.default.findIndex(function (item) { return item.name === TAB_NAV_ITEMS_NAME.EAQ_TOPIC_REPORT; });
            var insertIndex = eaqIndex !== -1 ? eaqIndex : prev.default.length;
            var updatedDefault = __spreadArray([], prev.default, true);
            updatedDefault.splice(insertIndex, 0, {
                name: TAB_NAV_ITEMS_NAME.ASSESSMENT_SUMMARY,
                paths: [PerformancePath.assessmentSummary, PerformancePath.assessmentDetail, PerformancePath.assessmentStudentDetail]
            });
            return __assign(__assign({}, prev), { default: updatedDefault });
        });
    }, [isSafeMedCourse]);
    useEffect(function () {
        if (!isCSApp && isEhrReportingEnabled && !isSafeMedCourse) {
            var tempExpandNavItems = [];
            tempExpandNavItems.unshift({ name: TAB_NAV_ITEMS_NAME.HESI_SPECIALTY_EXAM_READINESS, paths: [PerformancePath.hesiReadinessReport.home], isAlwaysActive: isHesiReadinessApp });
            var tempNavItems = Object.assign({}, navItems, { expand: tempExpandNavItems });
            setNavItems(tempNavItems);
        }
    }, [eaqTopicMappedHesiExamByCourseId, isHesiReadinessApp, isEhrReportingEnabled, isSafeMedCourse, isCSApp]);
    var goToHesiReadinessPage = function () {
        var performanceReportPage = (appLinkOutPostBody || {}).performanceReportPage;
        if (performanceReportPage !== APP_LINK_PAGE_NAME_WITH_ROUTE.PERFORMANCE_HESI_READINESS.name) {
            dispatch(appActions.setIsCWSubNavInEHRPageShow(true));
        }
        history.push(RoutePath.ehr);
    };
    var goToUrlPage = function (url) {
        history.push(url);
    };
    var renderNavItem = function (navItem) {
        var isAlwaysActive = navItem.isAlwaysActive, _a = navItem.paths, paths = _a === void 0 ? [] : _a, onClickCustomLink = navItem.onClickCustomLink, icon = navItem.icon, name = navItem.name;
        var isEAQTopicReportLink = onClickCustomLink && name === TAB_NAV_ITEMS_NAME.EAQ_TOPIC_REPORT && !isCSApp;
        if (isEAQTopicReportLink) {
            var isEAQTopicReportActive = isEAQTopicReportFFEnabled && checkPathMatch([PerformancePath.eaqTopicReport.home]);
            return renderNavButton(name, goToEAQReport, isEAQTopicReportActive);
        }
        var isHesiReadinessLink = name === TAB_NAV_ITEMS_NAME.HESI_SPECIALTY_EXAM_READINESS && !isCSApp;
        if (isHesiReadinessLink) {
            var isEHRPath = checkPathMatch(Object.values(ehrPath));
            return renderNavButton(name, goToHesiReadinessPage, isEHRPath);
        }
        var defaultPath = paths[0];
        var match = isAlwaysActive || checkPathMatch(paths);
        return (<button type="button" key={name} tabIndex={0} className={classNames('u-els-anchorize c-els-tab-group__item c-els-tab-group__item-link c-page-navigator__link-button', { 'c-els-tab-group__item--active': match })} onClick={function () { return goToUrlPage(defaultPath); }}>
        <span className="c-els-tab-group__text c-page-navigator__link-text">
          {name}
          {icon && <ELSIcon name={icon} size="1x"/>}
        </span>
      </button>);
    };
    var expand = navItems.expand;
    var isExistExpandNavItems = !!expand.length;
    var showDefaultNavItems = true;
    if (isHesiReadinessApp) {
        showDefaultNavItems = isCWSubNavInEHRPageShow;
    }
    return (<>
      {!windowMode.mobile && !isHADPath && (<div className="u-els-background-color-n0 c-page-navigator">
          <ul className="u-max-width-1400 c-cw-report-content c-els-tab-group c-page-navigator__menu">
            {showDefaultNavItems &&
                Object.values(navItems === null || navItems === void 0 ? void 0 : navItems.default).map(function (item) {
                    return renderNavItem(item);
                })}
            {isExistExpandNavItems && (<>
                {!isHesiReadinessApp && <ButtonMenu menuItems={Object.values(expand)}/>}
                {Object.values(expand).map(function (item) {
                    return renderNavItem(item);
                })}
              </>)}
            {isCWLinkHADAndEHRChecking && (<li className="c-els-tab-group__item">
                <ELSInlineLoader />
              </li>)}
          </ul>
          <div className="c-els-divider c-els-divider--1o2"/>
        </div>)}
      {openModal && !isHADPath && (<PageNavigatorModal navItems={navItems} handleCancel={handleCancel} activePageName={activePageName} isHesiReadinessApp={isHesiReadinessApp} goToEAQReport={goToEAQReport}/>)}
      {openModal && isHADPath && <HADPageNavigatorModal handleCancel={handleCancel} isHesiReadinessApp={isHesiReadinessApp}/>}
    </>);
};
export default withResizeScreen(withRedirectToOutsideApp(PageNavigator));
